import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useMst } from '../../../models/stores/Root';
import { ItemOptionContract } from '../../../types/Item';
import AlertModal from '../../content/AlertModal';
import CartItem from '../../content/CartItem';
import ErrorModal from '../../content/ErrorModal';

export const CartItemSummaryTestId = 'cartitemsummary-summary';

export type CartItemSummaryProps = {
  currencySymbol: string;
};

const CartItemSummary: React.FC<CartItemSummaryProps> = observer(
  ({ currencySymbol }: CartItemSummaryProps) => {
    const rootStore = useMst();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { cart } = rootStore;

    const [openModal, setOpenModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);

    const handleRemoveItem = async (
      cartItemId: number,
      itemOptions: ItemOptionContract[]
    ) => {
      if (!cartItemId) return;

      if (cart.onlyItem) {
        setOpenModal(true);
      } else {
        await rootStore
          .removeCartItemFlow(cartItemId, itemOptions)
          .catch(error => {
            // eslint-disable-next-line no-console
            console.error(error);
            setErrorModal(true);
          });
      }
    };

    const handleContinueButton = async () => {
      setOpenModal(false);

      if (cart.onlyItem) {
        await rootStore
          .removeCartItemFlow(cart.onlyItem.id, cart.onlyItem.options)
          .catch(error => {
            // eslint-disable-next-line no-console
            console.error(error);
            setErrorModal(true);
          });
      }
    };

    return (
      <div data-testid={CartItemSummaryTestId} className="text-sm min-h-1/4">
        {cart.cartData.items.map(cartItem => {
          let setupCost = 0;
          cartItem.kits?.forEach(entry => {
            if (entry.code === 'SETUP') {
              setupCost += entry.cost;
            }
          });
          let cartItemKey = String(cartItem.id);
          cartItem.options?.forEach(option => {
            if (option.optionText) {
              cartItemKey += option.optionText;
            } else if (option.id) {
              cartItemKey += option.id;
            }
          });
          return (
            <CartItem
              key={cartItemKey}
              name={cartItem.name}
              imgUrl={cartItem.imgUrl}
              options={cartItem.options}
              qty={cartItem.qty}
              currency={currencySymbol}
              unitPrice={cartItem.pricing.unitPrice}
              setupCost={setupCost}
              cartSubTotal={cartItem.pricing.subtotal}
              id={cartItem.id}
              handleRemoveItem={handleRemoveItem}
            />
          );
        })}
        {openModal && (
          <AlertModal
            handleContinueButton={handleContinueButton}
            setOpenModal={setOpenModal}
            headerText="Confirmation Required"
            bodyText="Are you sure you want to remove the only item in your cart? You will be redirected to the home page to continue shopping."
          />
        )}
        {errorModal && <ErrorModal />}
      </div>
    );
  }
);

export default CartItemSummary;
